import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Map, List } from 'immutable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isValid, reset } from 'redux-form';

import { Button } from 'semantic-ui-react';

import * as commonVar from 'libs/commonVar';

import * as templateLib from 'libs/templateLib';
import * as currentStatusActions from 'modules/currentStatus';
import * as templateActions from 'modules/template';

import { ExamTemplateReceiveTest } from 'components';

class CtExamTemplateReceiveTest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      progressing: false,
      receiveTestModal: false
    };
  }

  // 성공 실패시 알림창
  onToggleSnackbar = message => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: '' });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };

  getSmtpStatus = () => {
    this.setState({ progressing: false });
  };

  mountReceiveTestModal = () => {
    const { receiveTestModal } = this.state;
    const { ReduxFormReset } = this.props;
    ReduxFormReset('testTemplateReceived');

    if (receiveTestModal) {
      // 열려진 경우로 닫는다.
      this.setState({ receiveTestModal: false });
    } else {
      // 닫혀진 경우로 연다.
      this.setState({ receiveTestModal: true });
    }
  };

  testTemplateReceived = async () => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      formTestTemplateReceived,
      formTestTemplateReceivedIsValid,
      formTestTemplateReceivedStore,
      selectedTemplate
    } = this.props;

    if (!!formTestTemplateReceivedIsValid) {
      this.setState({ progressing: true });

      try {
        let snackbarMessage =
          defineMessages(formatMessage({ id: 'CtExamTemplateReceiveTest_1', defaultMessage: '수신 테스트' })) +
          ' ' +
          defineMessages(formatMessage({ id: 'ExamTemplateCopy_3', defaultMessage: '실행' }));

        const templateObj = JSON.parse(JSON.stringify(selectedTemplate));
        const tempList = JSON.parse(JSON.stringify(templateObj.examTemplateNoArray));
        const serviceTempList = JSON.parse(JSON.stringify(templateObj.serviceTemplateNoArray));

        const params = {
          forceTest: 0,
          examTemplateNoArray: tempList,
          serviceTemplateNoArray: serviceTempList
        };

        if (!!formTestTemplateReceived) {
          if (!!formTestTemplateReceived.forceTest) {
            params['forceTest'] = formTestTemplateReceived.forceTest;
          }
          if (!!formTestTemplateReceived.senderEmail) {
            params['senderEmail'] = formTestTemplateReceived.senderEmail;
            snackbarMessage = "'" + formTestTemplateReceived.senderEmail + "'" + snackbarMessage;
          }
        }
        // const respObj = await templateLib.testTemplateReceived(params);
        await templateLib.testTemplateReceived(params);

        // 결과값에 따른 처리
        this.onToggleSnackbar(snackbarMessage);
        // 성공 or 실패 처리

        this.setState({
          progressing: false,
          receiveTestModal: false
        });
      } catch (e) {
        console.log(e);
      }
    } else {
      window.markFieldValidate(formTestTemplateReceivedStore, 'testTemplateReceived');
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { receiveTestModal, progressing } = this.state;
    const { isAuth, user, selectedTemplate } = this.props;
    const { mountReceiveTestModal, testTemplateReceived, getSmtpStatus } = this;

    const templateObj = JSON.parse(JSON.stringify(selectedTemplate));
    const tempList = JSON.parse(JSON.stringify(templateObj.examTemplateNoArray));
    const serviceTempList = JSON.parse(JSON.stringify(templateObj.serviceTemplateNoArray));

    return (
      <div>
        {commonVar.isGs === 1 && isAuth === 2 ? (
          ''
        ) : (
            <Button
              className={tempList.length > 0 || serviceTempList.length > 0 ? 'bt-style-gleam common-button-gray' : 'bt-style-gleam common-button-gray disable'}
              size="small"
              content={defineMessages(
                formatMessage({ id: 'CtExamTemplateReceiveTest_1', defaultMessage: '수신 테스트' })
              )}
              onClick={mountReceiveTestModal}
            // color="blue"
            />
          )}
        {receiveTestModal && (
          <ExamTemplateReceiveTest
            isAuth={isAuth}
            user={user}
            progressing={progressing}
            handleOnToggleReceiveTestModal={mountReceiveTestModal}
            getSmtpStatus={getSmtpStatus}
            testTemplateReceived={testTemplateReceived}
          />
        )}
      </div>
    );
  }
}

CtExamTemplateReceiveTest.propTypes = {};
CtExamTemplateReceiveTest.defaultProps = {};

const mapStateToProps = (state, props) => ({
  user: state.user.get('user'),
  isAuth: state.user.get('isAuth'),
  selectedTemplate: state.template.get('selectedTemplate'),
  formTestTemplateReceivedStore: state.form['testTemplateReceived'],
  formTestTemplateReceived: getFormValues('testTemplateReceived')(state),
  formTestTemplateReceivedIsValid: isValid('testTemplateReceived')(state)
});

const mapDispatchToProps = dispatch => ({
  TemplateActions: bindActionCreators(templateActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtExamTemplateReceiveTest));



// WEBPACK FOOTER //
// ./src/script/containers/examTemplate/CtExamTemplateReceiveTest.js